"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _excluded = ["className", "trigger", "refExit", "hide", "content"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Popover = function Popover(_ref) {
  var className = _ref.className,
    trigger = _ref.trigger,
    refExit = _ref.refExit,
    hide = _ref.hide,
    content = _ref.content,
    providedProps = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    isOpen = _ref3[0],
    open = _ref3[1];
  var anchorEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (isOpen) {
      var shouldHide = typeof hide === 'boolean' ? hide : false;
      if (shouldHide) {
        open(false);
      }
    }
  }, [hide, isOpen, open]);
  var handleClick = function handleClick(event) {
    anchorEl.current = event.currentTarget;
    open(true);
  };
  var handleRequestClose = function handleRequestClose() {
    open(false);
  };
  var closeIconClass = providedProps.classes.closeIcon;
  delete providedProps.classes.closeIcon; // remove non-standard class from being passed to the popover component

  var transformOriginSpecs = {
    vertical: 'top',
    horizontal: 'center'
  };
  var anchorOriginSpecs = {
    vertical: 'bottom',
    horizontal: 'center'
  };
  var handleOnExit = function handleOnExit() {
    if (refExit) {
      refExit();
    }
  };
  var triggerProps = {
    key: 'content',
    onClick: function onClick(event) {
      if (trigger.props.onClick) trigger.props.onClick();
      handleClick(event);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", triggerProps, trigger), /*#__PURE__*/_react.default.createElement(_Popover.default, _extends({
    elevation: 2,
    open: isOpen,
    onClose: handleRequestClose,
    onExited: handleOnExit,
    anchorEl: anchorEl.current,
    anchorOrigin: anchorOriginSpecs,
    transformOrigin: transformOriginSpecs
  }, providedProps), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    "aria-label": "Close",
    onClick: handleRequestClose,
    className: closeIconClass,
    style: {
      position: 'absolute',
      right: '4px',
      top: '4px'
    }
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)), content));
};
Popover.propTypes = {
  refExit: _propTypes.default.func,
  trigger: _propTypes.default.node.isRequired,
  content: _propTypes.default.node.isRequired,
  hide: _propTypes.default.bool
};
var _default = Popover;
exports.default = _default;